import { Pipe, PipeTransform } from '@angular/core';
import { isDate } from 'lodash';

@Pipe({
  name: 'todayTommorow'
})
export class TodayTommorowPipe implements PipeTransform {

  transform(value: any): unknown {
    return this.todatTommorowFilter(value);
  }

  todatTommorowFilter(val: any){
    if(!val){
      return val;
    }

    // if (!isDate(val)) {
    //   return val;
    // }

    if(String(new Date(val)) == "Invalid Date"){
        return val;
    }

    let a = new Date(val).customFormat('#DD#-#MMM#-#YY#');
        let currDate = new Date().customFormat('#DD#-#MMM#-#YY#');
        let yesterDay = new Date(new Date().setDate(new Date().getDate() - 1)).customFormat('#DD#-#MMM#-#YY#');
        let tommorowDT = new Date(new Date().setDate(new Date().getDate() + 1)).customFormat('#DD#-#MMM#-#YY#');
        let dateyear = new Date(val).customFormat('#YYYY#');
        let curryear = new Date().customFormat('#YYYY#');
        let returnDate;

        if (dateyear == curryear) {
            if (a == currDate) {
                returnDate = 'Today';
            }
            else if (a == yesterDay) {
                returnDate = 'Yesterday';
            }
            else if (a == tommorowDT) {
                returnDate = 'Tomorrow';
            }
            else {
                returnDate = new Date(val).customFormat('#DD#-#MMM#');
            }
        }
        else {
            returnDate = new Date(val).customFormat('#DD#-#MMM#-#YY#');
        }
        return returnDate;
  }

}
